import styled, { css } from 'styled-components'

const ConversationPart = styled.div<{ type: 'date' | 'message' }>`
  width: 100%;

  ${props => props.type === 'date' && css`
    text-align: center;
    color: rgb(115, 115, 118);
    font-size: 13px;
    clear: both;
    padding-top: 14px;
    padding-bottom: 14px;
  `}

  ${props => props.type === 'message' && css`
    padding-bottom: 2px;

    &:last-child {
      padding-bottom: 24px;
    }
  `}
`

export default ConversationPart